import * as React from 'react';
import {Route, Link} from 'react-router-dom';

import classnames from 'classnames';

import {RouteContext} from '../../../../../../ui/route-context';

import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from '../../icon/svg/external-link-icon';
import {UpgradeArrowIconNewNav} from '../../icon/svg/upgrade-arrow-icon-new-nav';
import {StackLegacy} from '../../layout/stack/stack-legacy';

import {isLinkActive} from './helpers';
import {LinkText} from './link-text';
import {LinkWrapper} from './link-wrapper';

import styles from './link-item.module.css';

export type LinkConfig = {
    id: string;
    linkText: string | React.ReactNode;
    isBold?: boolean;
    to: string;
    path?: string;
    exact?: boolean;
    icon?: React.ComponentType<any> | string;
    requiresUpgrade?: boolean;
    activeMatch?: RegExp; // If provided, tested against url pathname to determine active state,
    searchMatch?: RegExp; // Matches against search params,
    onClick?: (e: React.SyntheticEvent<any>) => any; // If provided, will override the `to` prop,
    isSubmenuItem?: boolean;
    count?: number | string;
    isExternalLink?: boolean;
    warningTooltip?: string;
    isLegacyIcon?: boolean;
};

type Props = LinkConfig;

export const LinkItem = (props: Props) => {
    const {isLegacyIcon = true} = props;

    const Icon = props.icon;

    const isEmbedded = React.useContext(RouteContext).isEmbedded;

    return (
        <Route exact={props.exact} path={props.path ? props.path : props.to}>
            {({match}) => {
                const isActive = isLinkActive(
                    Boolean(match),
                    location.pathname,
                    location.search,
                    props.activeMatch,
                    props.searchMatch
                );

                return (
                    <li id={`linkItem-${props.id}`}>
                        <LinkWrapper
                            isActive={isActive}
                            isSubmenuItem={props.isSubmenuItem}
                            isEmbedded={isEmbedded}
                        >
                            {/* @ts-expect-error */}
                            <Link
                                to={props.onClick ? '#' : props.to}
                                onClick={handleClick(props.onClick)}
                            >
                                {props.isSubmenuItem && (
                                    <div
                                        className={classnames(styles['link-item-submenu-line'], {
                                            [styles.embedded]: isEmbedded,
                                        })}
                                    />
                                )}
                                {Icon ? (
                                    <div className={styles['link-item-icon']}>
                                        <Icon
                                            size={isLegacyIcon ? 14 : 17}
                                            wrapWithDiv={false}
                                            fill={colors.white}
                                            color={colors.white}
                                        />
                                    </div>
                                ) : undefined}
                                <div className='flex justify-sb align-center full-width'>
                                    <div>
                                        {typeof props.linkText === 'string' ? (
                                            <LinkText
                                                linkText={props.linkText}
                                                isBold={props.isBold}
                                                warningTooltip={props.warningTooltip}
                                            />
                                        ) : (
                                            props.linkText
                                        )}
                                    </div>
                                    <StackLegacy isHorizontal={true} spacing={4}>
                                        {typeof props.count !== 'undefined' && (
                                            <span className={styles['link-item-count']}>
                                                {props.count}
                                            </span>
                                        )}
                                        {props.requiresUpgrade && (
                                            <UpgradeArrowIconNewNav
                                                size={14}
                                                // @ts-expect-error
                                                color={colors.blue}
                                                alignCenter={true}
                                            />
                                        )}
                                        {props.isExternalLink && !props.requiresUpgrade && (
                                            <ExternalLinkIcon
                                                size={14}
                                                color={colors.blue}
                                                alignCenter={true}
                                            />
                                        )}
                                    </StackLegacy>
                                </div>
                            </Link>
                        </LinkWrapper>
                    </li>
                );
            }}
        </Route>
    );
};

// TODO: Move to shared utils
function handleClick(onClick?: (e: React.SyntheticEvent<any>) => void) {
    return (e: React.SyntheticEvent<any>) => {
        // Always reset scroll to the top of the window when clicking sidebar nav items
        window.scrollTo(0, 0);

        if (typeof onClick === 'function') {
            onClick(e);
        }
    };
}
